import { atom } from 'recoil'

import { RejectClaimModalProps } from './types'

const initRejectClaimModal: RejectClaimModalProps = false

const rejectClaimModalAtom = atom({
  key: 'rejectClaimModalAtom',
  default: initRejectClaimModal,
})

export default rejectClaimModalAtom
